import { getStoreScopedRedirectPath } from "../root-redirect";

export function getFaireCallbackPath(url: URL): string | undefined {
  if (url.pathname !== "/faire/callback") {
    return undefined;
  }

  const teamId = url.searchParams.get("state");
  if (!teamId || !/^[0-9a-f]{24}$/.test(teamId)) {
    return undefined;
  }

  return getStoreScopedRedirectPath(
    teamId,
    url.pathname + url.search + url.hash,
  );
}
